import { BookOpen } from "lucide-react";
import { ComingSoonPage } from "./ComingSoonPage";

export function WikiPage() {
  return <ComingSoonPage title="Wiki" description="Shared knowledge for the workspace." Icon={BookOpen} />;
}
